import { dashboardsPath } from 'adapter/in/common/routes';

const buildBaseUrl = (protocol: string, domain: string, port: number, apiPrefix: string, pathUrl: string): string => {
    const regexMatchLink = pathUrl.match(/(\/links\/[^/]*)(\/dashboards\/[^/]*)/);
    let url = `${protocol}//${domain}${port === 80 ? '' : `:${port}`}${apiPrefix}`;

    if (regexMatchLink?.length === 3) {
        url = `${url}/${dashboardsPath}${regexMatchLink[2]}${regexMatchLink[1]}/proxy/api-v3`;
    }

    return url;
};

export default buildBaseUrl;
